export default function ReviewResultCN({ answer, error, loading, onCopy }) {
  return (
    <div className="reviewResult mrt30">
      <div className="answer">
        <h4>AI答辩结果 :</h4>

        {loading ? (
          <p>创建中... 请稍等。</p>
        ) : error ? (
          <p className="error">{error}</p>
        ) : answer ? (
          <p>{answer}</p>
        ) : (
          <p>粘贴评论后点击"生成评论回答"。</p>
        )}

        <div>
          <button className="copy" onClick={onCopy} disabled={!answer}>
            复制答复
          </button>
        </div>
      </div>
    </div>
  );
}
